import * as React from 'react';

import { cn } from '../../styles/lib/utils';

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        ref={ref}
        type={type}
        data-slot="input"
        className={cn(
          'h-7 w-full min-w-0 rounded border bg-white px-2 py-1 text-xs leading-[1.4] text-grey-80 placeholder:text-grey-50 transition-[color,box-shadow,border-color] outline-none',
          'border-grey-30',
          'focus-visible:border-focus',
          'disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-grey-10',
          'file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-grey-80',
          'aria-invalid:border-destructive aria-invalid:ring-destructive/20',
          'dark:bg-white/30 dark:aria-invalid:ring-destructive/40',
          className,
        )}
        {...props}
      />
    );
  },
);

Input.displayName = 'Input';

export { Input };
